import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

// TECH-DEBT: we can probably cache unfiltered results in the store
const useIdentities = (queryString, params = {}, options = {}) => {
  const [identities, setIdentities] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const getIdentities = () => {
    if (options.skip) {
      setIsLoading(false)
      setHasLoadError(false)
      return
    }

    setIsLoading(true)

    let url = '/api/identity'
    if (queryString) url += `?name=${queryString}`

    Object.keys(params).forEach((key) => {
      const value = params[key]
      const char = url.includes('?') ? '&' : '?'
      url += `${char}${key}=${value}`
    })

    return authedAxios
      .get(url)
      .then((res) => {
        setIdentities(res.data.identities)
        setIsLoading(false)
      })
      .catch((e) => {
        setHasLoadError(e)
      })
  }

  useEffect(() => {
    getIdentities()
  }, [queryString, options.skip])

  return { identities, isLoading, hasLoadError }
}

export default useIdentities
